// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile-name[data-v-6fbcd389]{background:-webkit-linear-gradient(135deg,#2276db,#a52550);-webkit-background-clip:text;-webkit-text-fill-color:transparent;font-weight:1000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
